<template>
  <div class="logs-timeline">
    <div class="d-flex align-items-center gap-2 mb-4 mt-4">
      <i class="fa fa-history text-primary"></i>
      <h5 class="mb-0 fw-bold text-dark">Order Logs</h5>
    </div>

    <div v-if="logs && logs.length" class="timeline-container position-relative">
      <div class=" position-absolute start-0 top-0 h-100"></div>

      <div v-for="(log, index) in logs" :key="log.id || index" class="timeline-item position-relative mb-3">
        <div class="timeline-dot position-absolute"></div>
        
        <div class="timeline-entry">
          <div class="d-flex align-items-center gap-2 mb-1">
            <span class="fw-bold text-dark fs-6">{{ performerName(log.performer) || 'System' }}</span>
            <small class="text-secondary opacity-75 font-monospace">{{ formatDate(log.created_at) }}</small>
          </div>
          
          <div class="activity-badge d-inline-block rounded px-2 py-1 text-dark border border-light-subtle">
            {{ log.activity || 'Log entry' }}
            
            <!-- <div v-if="log.meta" class="smaller-text mt-1 text-muted border-top pt-1">
              {{ parseMeta(log.meta) }}
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div v-else class="text-center text-muted py-4 small italic">
      No activity logs available.
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogsTimeline',
  props: {
    logs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return ''
      const date = new Date(value)
      // Custom format to match "MM/DD/YYYY, H:MM PM" exact image view
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }) + ', ' + date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    },
    performerName(performer) {
      if (!performer) return ''
      return [performer.first_name, performer.last_name].filter(Boolean).join(' ') || ''
    },
    parseMeta(meta) {
      if (!meta) return ''
      try {
        const parsed = typeof meta === 'string' ? JSON.parse(meta) : meta
        if (typeof parsed === 'object' && parsed !== null) {
          return Object.entries(parsed).map(([key, value]) => `${this.readableKey(key)}: ${value}`).join(' · ')
        }
        return String(parsed)
      } catch (error) {
        return String(meta)
      }
    },
    readableKey(key) {
      return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase())
    }
  }
}
</script>
<style scoped>
.logs-timeline {
  padding: 0.25rem 0.1rem;
}

.timeline-container {
  padding-left: 3px;
}

/* Slim vertical connecting line */
.timeline-line {
  width: 2px;
  background-color: #e9ecef;
  left: 5px;
}

.timeline-item {
  padding-left: 1.75rem;
}

.timeline-item:last-child {
  margin-bottom: 0 !important;
}

/* Bullet indicator aligning with the text height */
.timeline-dot {
  width: 12px;
  height: 12px;
  top: 6px;
  left: 0;
  border-radius: 50%;
  background-color: var(--primary-color); /* Adjust color scheme to match your theme */
  border: 2.5px solid #ffffff;
  box-shadow: 0 0 0 1px #e9ecef;
  z-index: 2;
}

.timeline-entry {
  display: flex;
  flex-direction: column;
}

/* The tight content box matching the layout background */
.activity-badge {
  background-color: white; /* Adjust color scheme to match your theme */
  font-size: 0.9rem;
  max-width: max-content;
  line-height: 1.4;
}

.smaller-text {
  font-size: 0.75rem;
}
</style>